import { deprecate } from "react-is-deprecated";

export function isDeprecated(propType, propName, additionalMessage) {
    let message = `The ${propName} prop is deprecated`;
    if (additionalMessage != null) {
        message += `:\n${additionalMessage}`;
    }
    return deprecate(propType, message);
}